import _ from 'lodash';
import GatewayService from '../GatewayService.js';
var gradeSyncService = new GatewayService('lms-grade-sync-svc');
import { missingParam } from '../errors.js';
import log from '../log.js';

var pingGradeSync = function pingGradeSync() {
  return gradeSyncService.get('liveops/ping');
};

var getGradeSyncStatus = function getGradeSyncStatus() {
  return gradeSyncService.get('liveops/status');
};

var getGradeSyncVersion = function getGradeSyncVersion() {
  return gradeSyncService.get('liveops/version');
}; // Assumes we will only be syncing one activity at a time


var postNewSync = function postNewSync(courseId, cardstackKey, cardstackTitle, maxScore, scores, teacherId, tagId, resourceDueDate) {
  if (_.isEmpty(courseId)) {
    log.error('Grades not synced because courseId was not specified');
    return Promise.reject(missingParam('courseId'));
  }

  if (_.isEmpty(cardstackKey)) {
    log.error('Grades not synced because cardstackKey was not specified');
    return Promise.reject(missingParam('cardstackKey'));
  }

  if (_.isEmpty(cardstackTitle)) {
    log.error('Grades not synced because cardstackTitle was not specified');
    return Promise.reject(missingParam('cardstackTitle'));
  }

  if (_.isNil(maxScore)) {
    log.error('Grades not synced because maxScore was not specified');
    return Promise.reject(missingParam('maxScore'));
  }

  if (_.isEmpty(scores)) {
    log.error('Grades not synced because no scores were given');
    return Promise.reject(missingParam('scores'));
  }

  if (_.isEmpty(teacherId)) {
    log.error('Grades not synced because teacherId was not specified');
    return Promise.reject(missingParam('teacherId'));
  }

  var body = {
    courseId: courseId,
    gradableItems: [{
      resourceId: cardstackKey,
      resourceLabel: cardstackTitle,
      maxScore: "".concat(maxScore),
      scores: scores
    }],
    initiatorUserBk: teacherId
  };
  if (tagId) body.tagId = tagId; // add resourceDueDate to the payload if it was set.
  // https://amplify-education.atlassian.net/browse/PANDA-311

  if (resourceDueDate) {
    body.gradableItems[0].resourceDueDate = resourceDueDate;
  }

  return gradeSyncService.post('v1/sync', body);
};

var cancelSyncJob = function cancelSyncJob(syncKey) {
  return gradeSyncService["delete"]("v1/sync/".concat(syncKey));
};

var getSyncJob = function getSyncJob(syncKey) {
  return gradeSyncService.get("v1/sync/".concat(syncKey));
};

var getAllSyncsForUser = function getAllSyncsForUser(userKey) {
  return gradeSyncService.get("v1/users/".concat(userKey, "/syncs"));
};

export default {
  pingGradeSync: pingGradeSync,
  getGradeSyncStatus: getGradeSyncStatus,
  getGradeSyncVersion: getGradeSyncVersion,
  postNewSync: postNewSync,
  cancelSyncJob: cancelSyncJob,
  getSyncJob: getSyncJob,
  getAllSyncsForUser: getAllSyncsForUser
};